import { render, staticRenderFns } from "./DictationWordLabel.vue?vue&type=template&id=c34a479e&"
import script from "./DictationWordLabel.vue?vue&type=script&lang=js&"
export * from "./DictationWordLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports